import type { ElementType, ReactElement } from 'react'
import { COLOR_STYLES, type StatColour } from './summary-view.colours'

interface StatCardProps {
  title: string
  value: string | number
  icon: ElementType
  color: StatColour
}

export function StatCard({ title, value, icon: Icon, color }: StatCardProps): ReactElement {
  const styles = COLOR_STYLES[color]
  return (
    <div
      className="rounded-xl border p-5"
      style={{ borderColor: 'var(--card-border)', background: 'var(--bg-card)' }}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium" style={{ color: 'var(--text-muted)' }}>
            {title}
          </p>
          <p className="mt-1 text-2xl font-semibold" style={{ color: 'var(--text)' }}>
            {value}
          </p>
        </div>
        <div className="rounded-lg p-3" style={{ background: styles.bg }}>
          <Icon className="h-5 w-5" style={{ color: styles.icon }} />
        </div>
      </div>
    </div>
  )
}
